import Courses from "../components/Adminitems/Courses";
import DashBoard from "../components/Adminitems/DashBoard";
import EditPage from "../components/Adminitems/EditPage";
import TeacherInsights from "../components/Adminitems/TeacherInsights";
import TeacherEditPage from "../components/TeacherComponents/EditPage";
import AddCourse from "../components/Adminitems/AddCourse";
import Add from "../components/Adminitems/Add";
import LandingPage from "../Pages/LandingPage";
import PageNotFound from "../Pages/PageNotFound";
import NotAllowed from "../Pages/NotAllowed";
import UserDashboard from "../Pages/UserDashboard";
import UserLayout from "../components/UserComponents/UserLayout";
import React from "react";
import { Route, Routes } from "react-router-dom";
import Setting from "../components/Adminitems/Setting";
import Users from "../components/Adminitems/Users";
import SinglePage from "../components/singlePageComps/SinglePage";
import Login from "../components/LogIn";
import AddUser from "../components/Adminitems/AddUser";
import EditUser from "../components/Adminitems/EditUsers";
import ProfilePage from "../Pages/ProfilePage";
import PrivateRoutes from "./PrivateRoutes";
import { AdminRoute } from "./AdminRoute";
import TeachVerify from "../components/TeacherComponents/TeachVerify";
import TeacherDashboard from "../components/TeacherComponents/TeacherDashboard";
import { TeacherRoute } from "./TeacherRoute";
import TeacherCourses from "../components/TeacherComponents/TeacherCourses";
import AddTeacherCourse from "../components/TeacherComponents/AddCourse";
import ManagerDashboard from "../components/ManagerDashboard";
import ProjectGroups from "../components/Adminitems/ProjectGroups";
import CertificatePage from "../Pages/CertificatePage";
import SsoCallback from "../Pages/SsoCallback";
import CategoryManager from "../components/Adminitems/CategoryManager";
import VerifyCertificate from "../Pages/VerifyCertificate";
import UploadLnaQuiz from "../components/AdminComponents/UploadLnaQuiz";
import LnaQuizzes from "../Pages/LnaQuizzes";
import TakeLnaQuiz from "../Pages/TakeLnaQuiz";
import TakeLnaQuizResult from "../Pages/TakeLnaQuizResult";
import MyInsights from "../Pages/MyInsights";
import EmployeeInsights from "../Pages/EmployeeInsights";

const AllRoute = () => {
    return (
    <Routes>
      <Route
        path="/sso"
        element={<SsoCallback />}
      />
      <Route
        path="/verify-certificate/:id"
        element={<VerifyCertificate />}
      />
      <Route
        path="/not-allowed"
        element={<NotAllowed />}
      />
      <Route
        path="/admin/groups"
        element={
          <PrivateRoutes>
            <AdminRoute>
              <UserLayout><ProjectGroups /></UserLayout>
            </AdminRoute>
          </PrivateRoutes>
        }
      />
      <Route
        path="/course/:id"
        element={
          <PrivateRoutes>
            <UserLayout>
              <SinglePage />
            </UserLayout>
          </PrivateRoutes>
        }
      />

      <Route
        path="/admin/dashboard"
        element={
          <PrivateRoutes>
            <AdminRoute>
              <UserLayout><DashBoard /></UserLayout>
            </AdminRoute>
          </PrivateRoutes>
        }
      />
      <Route
        path="/admin/categories"
        element={
          <PrivateRoutes>
            <AdminRoute>
              <UserLayout><CategoryManager /></UserLayout>
            </AdminRoute>
          </PrivateRoutes>
        }
      />
      <Route
        path="/admin/upload-lna-quiz"
        element={
          <PrivateRoutes>
            <AdminRoute>
              <UserLayout><UploadLnaQuiz /></UserLayout>
            </AdminRoute>
          </PrivateRoutes>
        }
      />
      <Route
        path="/admin/courses"
        element={
          <PrivateRoutes>
          <AdminRoute>
          <UserLayout><Courses /></UserLayout>
          </AdminRoute>
          </PrivateRoutes>
        }
      />

      <Route
        path="/admin/edit/:id"
        element={
          <PrivateRoutes>
          <AdminRoute>
          <UserLayout><EditPage /></UserLayout>
          </AdminRoute>
          </PrivateRoutes>
        }
      />
      <Route
        path="/admin/addCourse"
        element={
          <PrivateRoutes>
          <AdminRoute>
          <UserLayout><AddCourse /></UserLayout>
          </AdminRoute>
          </PrivateRoutes>
        }
      />



      <Route
        path="/admin/Add"
        element={
          <PrivateRoutes>
          <AdminRoute>
          <UserLayout><Add /></UserLayout>
          </AdminRoute>
          </PrivateRoutes>
        }
      />

      <Route
        path="/lna-quiz/:id/result"
        element={
          <PrivateRoutes>
            <UserLayout>
              <TakeLnaQuizResult />
            </UserLayout>
          </PrivateRoutes>
        }
      />

      <Route
        path="/home"
        element={
          <PrivateRoutes>
            <UserLayout>
              <UserDashboard />
            </UserLayout>
          </PrivateRoutes>
        }
      />
      <Route
        path="/lna-quizzes"
        element={
          <PrivateRoutes>
            <UserLayout>
              <LnaQuizzes />
            </UserLayout>
          </PrivateRoutes>
        }
      />
      <Route
        path="/lna-quiz/:id"
        element={
          <PrivateRoutes>
            <UserLayout>
              <TakeLnaQuiz />
            </UserLayout>
          </PrivateRoutes>
        }
      />
      <Route
        path="/my-insights"
        element={
          <PrivateRoutes>
            <UserLayout>
              <MyInsights />
            </UserLayout>
          </PrivateRoutes>
        }
      />
      <Route
        path="/admin/employee-insights"
        element={
          <PrivateRoutes>
            <AdminRoute>
              <UserLayout><EmployeeInsights /></UserLayout>
            </AdminRoute>
          </PrivateRoutes>
        }
      />
      <Route
        path="/admin/teacher-insights"
        element={
          <PrivateRoutes>
            <AdminRoute>
            <UserLayout><TeacherInsights /></UserLayout>
            </AdminRoute>
          </PrivateRoutes>
        }
      />

      <Route
        path="/admin/setting"
        element={
          <PrivateRoutes>
           <AdminRoute>
           <UserLayout><Setting /></UserLayout>
           </AdminRoute>
          </PrivateRoutes>
        }
      />
      <Route
        path="/admin/users"
        element={
          <PrivateRoutes>
            <AdminRoute>
            <UserLayout><Users /></UserLayout>
            </AdminRoute>
          </PrivateRoutes>
        }
      />
      <Route
        path="/admin/users/add"
        element={
          <PrivateRoutes>
           <AdminRoute>
           <UserLayout><AddUser /></UserLayout>
           </AdminRoute>
          </PrivateRoutes>
        }
      />
      <Route
        path="/admin/users/edit/:id"
        element={
          <PrivateRoutes>
            <AdminRoute>
            <UserLayout><EditUser /></UserLayout>
            </AdminRoute>
          </PrivateRoutes>
        }
      />

      <Route
        path="/admin/certificates"
        element={
          <PrivateRoutes>
            <AdminRoute>
              <UserLayout>
                <CertificatePage />
              </UserLayout>
            </AdminRoute>
          </PrivateRoutes>
        }
      />
       <Route
              path="/Teacher/edit/:id"
              element={
                <PrivateRoutes>
                <TeacherRoute>
                <UserLayout><TeacherEditPage /></UserLayout>
                </TeacherRoute>
                </PrivateRoutes>
              }
            />



      <Route path="/" element={<LandingPage />} />
      <Route path="*" element={<PageNotFound />} />
      {process.env.REACT_APP_DEV_ALLOW_PASSWORD_LOGIN === 'true' && (
        <Route path="/login" element={<Login />} />
      )}
      <Route path="/superadmin/login" element={<Login />} />
  
      <Route
        path="/Teachme"
        element={
          <PrivateRoutes>
            <UserLayout><TeachVerify/></UserLayout>
          </PrivateRoutes>
        }
      />
      
      <Route
        path="/teacher-dashboard"
        element={
          <PrivateRoutes>
            <TeacherRoute>
            <UserLayout><TeacherDashboard/></UserLayout>
            </TeacherRoute>
          </PrivateRoutes>
        }
      />
      <Route
        path="/manager/dashboard"
        element={
          <PrivateRoutes>
            <TeacherRoute>
              <UserLayout><ManagerDashboard /></UserLayout>
            </TeacherRoute>
          </PrivateRoutes>
        }
      />

      <Route
        path="/Teacher/courses"
        element={
          <PrivateRoutes>
            <TeacherRoute>
            <UserLayout><TeacherCourses/></UserLayout>
            </TeacherRoute>
          </PrivateRoutes>
        }
      />

      <Route
        path="/Teacher/users"
        element={
          <PrivateRoutes>
            <TeacherRoute>
            <UserLayout><Users/></UserLayout>
            </TeacherRoute>
          </PrivateRoutes>
        }
      />



      <Route
        path="/Teacher/addCourse"
        element={
          <PrivateRoutes>
            <TeacherRoute>
            <UserLayout><AddTeacherCourse/></UserLayout>
            </TeacherRoute>
          </PrivateRoutes>
        }
      />


      <Route
        path="/profile"
        element={
          <PrivateRoutes>
            <UserLayout>
              <ProfilePage />
            </UserLayout>
          </PrivateRoutes>
        }
      />
    </Routes>
  );
};

export default AllRoute;
